<template>
  <div>
    <base-button
      small
      color="#00ED64"
      @click="onOpenKeyDialog"
    >
      <span>{{ $t('workspace.api_keys') }}</span>
    </base-button>
    <v-menu
      open-on-hover
      top
      offset-y
      v-if="keys.length > 0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          rounded
          depressed
          class="text-none"
        >
          {{ $t('workspace.api_keys_url') }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="key in keys"
          :key="key.id"
          @click="onOpenKeyGenerateUrlDialog(key)"
        >
          <v-list-item-title>{{ key.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <KeyDialog ref="dialog" :workspace="workspace" />
    <KeyGenerateUrlDialog ref="urlDialog" :workspace="workspace" :wid="workspace.items[0].id"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KeyDialog from '../keys/key-dialog-request.vue'
import KeyGenerateUrlDialog from '../keys/key-generate-url-dialog.vue'
import { EDIT_TYPE } from '@constant'
import axios from '@service/auth-sdk'
export default{
  components: {
    KeyDialog,
    KeyGenerateUrlDialog
  },
  data: () => ({
    keys: []
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },
  props: {
    workspace: { type: Object, required: true },
  },
  created(){
    this.getKeys()
  },
  methods: {
    onOpenKeyDialog() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onOpenKeyGenerateUrlDialog(key) {
      this.$refs.urlDialog.open(key)
    },
    getKeys(){
      axios.get('ws-key-apis', {
        params: {
          workspace_id: this.workspace.items[0].id,
          uuid: this.currentUser.id,
          with: 'created_by,workspaces'
        }
      })
      .then(response => {
        this.keys = response.data
      })
    }
  }
}
</script>

<style scoped>

</style>
